import React from "react";
// import Button from "../Button/Button";
import "./1vs1.css";
import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import { GamePopupContext } from "../Context/GamePopupContext";
import { useContext } from "react";
import { CodeContext } from "../../component/Context/CodeContext";
import { useEffect } from "react";
import { motion } from "framer-motion";
import useOneVOneContract from "../../Hooks/OneVOneContract";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../AuthContext";
function Addbuddy(props) {
  const [Loaded, setLoaded] = useState(false);
  const { dispatchPopUp, gameState } = useContext(GamePopupContext);
  const { state } = useContext(CodeContext);
  const [copyLink, setCopyLink] = useState(false);
  const [copyLinkBtn, setCopyLinkBtn] = useState(false);
  const [invitelLink, setInviteLink] = useState("");
  const navigate = useNavigate();
  const { GameId } = useOneVOneContract();
  const { walletBalance } = useAuthContext();
  const copyTextHandler = () => {
    setInviteLink(state?.code);
    navigator?.clipboard?.writeText(state?.code);
    setCopyLink(true);
    setCopyLinkBtn(true);
    setTimeout(() => {
      setCopyLink(false);
    }, 4000);
  };
  useEffect(() => {
    setLoaded(true);
    setTimeout(() => {
      setLoaded(false);
    }, 3000);
    if (gameState.showInviteModal === true && gameState.buddyData) {
      GameId(
        gameState?.buddyData?.type,
        gameState?.buddyData?.value,
        gameState?.buddyData?.game,
        false,
        gameState?.buddyData?.isCustomBet,
        gameState?.buddyData?.gameType,
        false
      );
    }
  }, [gameState.showInviteModal]);
  const handlePropGameChange = () => {
    console.log(gameState);
    navigate(`/match`, {
      state: {
        id: gameState?.buddyData?.id,
        type: gameState?.buddyData?.type,
        value: parseInt(gameState?.buddyData?.value),
        name: gameState?.buddyData?.game,
        gameBuild: gameState?.buddyData?.gameBuild,
        gameClass: gameState?.buddyData?.gameClass,
        isCustomBet: true,
        gameType: "PlayWithFriend",
        direct: true,
      },
    });
  };
  return (
    <motion.div
      className={`col-lg-2 games`}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Modal
        show={gameState.showInviteModal}
        onHide={() => dispatchPopUp({ type: "close" })}
        className="gamescreen-modal"
      >
        <div className="section-onevsone add-buddy">
          <div className={`container ${Loaded ? "fade-class" : ""}`}>
            <div className="row matic-row">
              <div className="col-lg-6">
                <div className="matic-info">
                  <div className="matic-image">
                    <img src={require("./images/matic.png")} alt="matic" />
                  </div>
                  <div className="matic-text">
                    <h3>{(walletBalance?.balance / 10 ** 18).toFixed(3)}</h3>
                    <p>Matic Available</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 cancel-image">
                <img
                  src={require("./images/cancel-error-popup.png")}
                  onClick={() => dispatchPopUp({ type: "close" })}
                  alt="popup"
                />
              </div>
            </div>
            <div className="row text-head">
              <div className="col-lg-12">
                <h1>Room code: {state?.code}</h1>
              </div>
            </div>
            <div className="row match-row">
              <div className="col-lg-5 men-image">
                <img src={require("./images/men.png")} alt="men" />
              </div>
              <div className="col-lg-2">
                <h1>VS</h1>
              </div>
              <div className="col-lg-5 add-budy">
                <img
                  src={require("./images/add-buddy.png")}
                  onClick={() => copyTextHandler()}
                  alt="buddy"
                />
                {copyLink ? (
                  <span className="copy-invite">
                    Copied to clipboard! {invitelLink}
                  </span>
                ) : (
                  <span>
                    Click here to invite your facebook friends/ buddies to play
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="row margin-bottom-some">
            <div className="col-12 text-center">
              {copyLinkBtn ? (
                <button
                  className="btn-styling"
                  type="button"
                  onClick={() => {
                    handlePropGameChange();
                  }}
                >
                  Play Game
                </button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </Modal>
    </motion.div>
  );
}
export default Addbuddy;
